<template>
  <v-row no-gutters class="fill-height" align="center" >
    <v-col :class="`primary darken-1 elevation-8 pa-8 ${$vuetify.breakpoint.name != 'xs' ? 'fill-height d-flex align-content-center flex-wrap justify-center' : ''}`" cols="12" sm="6" :style="{'background-image': 'url(' + require('@/assets/water-drop-wallpaper.svg') + ')', 'background-repeat': 'no-repeat', 'background-size': backgroundSize}">
      <Logo/>
    </v-col>

    <v-col class="pa-8 mt-n15" cols="12" sm="6">
      <router-view></router-view>
    </v-col>

  </v-row>

</template>

<script>
import Logo from '@/components/auth/Logo';
export default {
    name: 'Login',
    components:{
        Logo
    },
    computed:{
      backgroundSize () {
        let size = '100%';
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            size = 'auto';
            break;
          case 'sm':
            size = 'auto';
            break;
        }

        return size;
      }
    }
}
</script>

<style>

</style>
